import { createAction, handleActions } from "redux-actions";
import TYPE from "../../constant/TYPE";

const SET = 'notepad.SET';
const SET_RECOGNIZE_RANGE = 'keypad.SET_RECOGNIZE_RANGE';
const SET_OVER_STROKE = 'noteped.SET_OVER_STROKE';
const SET_REMOVE_STROKE = 'noteped.SET_REMOVE_STROKE';
const CLEAR = 'notepad.CLEAR';

const defaultState = {
  data : [],
  recognizeRange : '',
  isShowClearButton : false,
  isErase: false,
  canvasDraw : {},
  isOverStroke: false,
  isOverStrokeDisabled: false,
  isEditing: false,
};

const setNotepadAction = createAction( SET, payload => payload );
const setRecognizeRangeAction = createAction( SET_RECOGNIZE_RANGE, payload => payload );
const setIsOverStrokeAction = createAction(SET_OVER_STROKE);
const setIsOverRemoveStrokeAction = createAction(SET_REMOVE_STROKE);
const clearNotepadAction = createAction( CLEAR );

const recognizeRangeData = {
  [ TYPE.KEYPAD.NUMBER ] : TYPE.RECOGNIZE_RANGE.ELEMENTARY.TYPE1,
  [ TYPE.KEYPAD.CALCULATION ] : TYPE.RECOGNIZE_RANGE.ELEMENTARY.TYPE3,
  [ TYPE.KEYPAD.COMPLEX_CALCULATION ] : TYPE.RECOGNIZE_RANGE.MIDDLE.TYPE1
};

const notepad = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ SET_OVER_STROKE ] : (state) => ({ ...state, isOverStroke: true, isOverStrokeDisabled: true }),
  [ SET_REMOVE_STROKE ] : (state) => ({ ...state, isOverStroke: false }),
  [ SET_RECOGNIZE_RANGE ] : ( state, action ) => ( { ...state, recognizeRange : recognizeRangeData[ action.payload ] } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default notepad;
export { setNotepadAction, setRecognizeRangeAction, clearNotepadAction, setIsOverStrokeAction, setIsOverRemoveStrokeAction };
